<!-- Форма выбора транспорта и путевого листа перед созданием акта. -->
<template>
  <form :id="formId" @submit.prevent="submit">
    <BaseFormField label="Автопарк" for-id="inspection-fleet-park" wide :filled="Boolean(fleetParkId)">
      <FleetParkSelect
        id="inspection-fleet-park"
        :model-value="fleetParkId"
        placeholder="Все автопарки"
        :with-button="false"
        @update:model-value="handleFleetParkChange"
      />
    </BaseFormField>
    <BaseFormField
      label="Транспорт"
      for-id="inspection-vehicle"
      required
      wide
      :filled="Boolean(vehicleId)"
      :error="vehicleError"
      error-message="Выберите транспорт"
    >
      <VehicleSelect
        id="inspection-vehicle"
        v-model="vehicleId"
        :fleet-park-id="fleetParkId"
        :clearable="false"
        @update:model-value="vehicleError = false"
      />
    </BaseFormField>
    <BaseFormField label="Путевой лист" for-id="inspection-waybill" wide :filled="Boolean(waybillId)">
      <WaybillSelect
        id="inspection-waybill"
        v-model="waybillId"
        placeholder="Можно выбрать путевой лист"
        :with-button="false"
      />
    </BaseFormField>
  </form>
</template>

<script>
import FleetParkSelect from "@/components/Vehicle/FleetParkSelect.vue";
import VehicleSelect from "@/components/Vehicle/VehicleSelect.vue";
import WaybillSelect from "@/components/Waybill/WaybillSelect.vue";
import { useVehicleStore } from "@/stores/vehicleStore";

export default {
  name: "VehicleInspectionSelectionForm",
  components: { FleetParkSelect, VehicleSelect, WaybillSelect },
  props: {
    formId: { type: String, required: true },
    initialVehicle: { type: Object, default: null },
  },
  emits: ["submit", "submitting-change"],
  data() {
    return {
      fleetParkId: null,
      vehicleId: this.initialVehicle?.id || null,
      waybillId: null,
      vehicleError: false,
      isSubmitting: false,
    };
  },
  computed: {
    vehicleStore() { return useVehicleStore(); },
  },
  methods: {
    handleFleetParkChange(value) {
      this.fleetParkId = value;
      this.vehicleId = null;
      this.vehicleError = false;
    },
    async submit() {
      if (!this.vehicleId) {
        this.vehicleError = true;
        return;
      }

      this.setSubmitting(true);
      try {
        const vehicle = String(this.initialVehicle?.id) === String(this.vehicleId)
          ? this.initialVehicle
          : await this.vehicleStore.fetchVehicleSelectItem(this.vehicleId);
        this.$emit("submit", { vehicle, waybillId: this.waybillId });
      } finally {
        this.setSubmitting(false);
      }
    },
    setSubmitting(value) {
      this.isSubmitting = value;
      this.$emit("submitting-change", value);
    },
  },
};
</script>
